<nb-card accent="success" style="margin: auto; height: 100%" class="own-scroll">
  <nb-card-header>
    <div class="d-flex">
      <div class="flex-grow-1 d-flex align-items-center justify-content-center">
        <nb-icon icon="pie-chart-outline"></nb-icon>
        <div class="ml-2" i18n>Campaign Stats: {{ campaign.id }}</div>
      </div>
      <button nbButton class="ml-3" (click)="close()">
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>
  <nb-card-body class="own-scroll">
    <h6 class="text-uppercase" i18n>Campaign Details</h6>
    <hr />
    <dl class="row">
      <div class="col" *ngIf="campaign.name">
        <dt class="col" i18n>Campaign Name:</dt>
        <dd class="col">{{ campaign.name }}</dd>
      </div>
      <div class="col" *ngIf="campaign.created_by">
        <dt class="col" i18n>Creator:</dt>
        <dd class="col">{{ campaign.created_by }}</dd>
      </div>
      <div class="col" *ngIf="campaign.created_dttm">
        <dt class="col" i18n>Time Created:</dt>
        <dd class="col">{{ campaign.created_dttm * 1000 | date : 'medium' }}</dd>
      </div>
    </dl>
    <h6 class="text-uppercase" i18n>Stats</h6>
    <hr />
    <nb-card>
      <nb-card-header class="d-flex">
        <div class="col-auto mr-auto" i18n>Deliveries</div>
        <div class="col-6">
          <ng-select
            id="timeFrame"
            name="timeFrame"
            (change)="fetchDeliveries()"
            placeholder="Select timeFrame"
            i18n-placeholder
            [(ngModel)]="choosenTime"
            style="width: 105%"
            [searchable]="false"
            [clearable]="false"
            required
          >
            <ng-option *ngFor="let time of timeFrame" [value]="time.value">{{ time.name }}</ng-option>
          </ng-select>
        </div>
      </nb-card-header>
      <span *ngIf="chartData.data">
        <nb-card-body *ngIf="chartData.data.length > 0">
          <div>
            <canvas baseChart type="bar" [data]="data" [options]="options"></canvas>
          </div>
        </nb-card-body>
      </span>
      <nb-card-body *ngIf="!chartData.data || chartData.data.length <= 0">
        <div class="col-auto mr-auto" i18n>There is no data for the selected time frame.</div>
      </nb-card-body>
    </nb-card>
    <dl class="d-flex">
      <dt class="col" i18n>Total Executions:</dt>
      <dd class="col">{{ campaign.executions }}</dd>
      <dt class="col" i18n>Average Execution Time:</dt>
      <dd class="col">{{ getAverageExecDuration() }}</dd>
    </dl>
    <dl class="d-flex">
      <dt class="col" i18n>Last Campaign Run:</dt>
      <dd class="col">{{ campaign.last_run_time * 1000 | date : 'medium' }}</dd>
      <dt class="col" i18n>Total Deliveries:</dt>
      <dd class="col">{{ count }}</dd>
    </dl>
  </nb-card-body>
  <nb-card-footer>
    <div class="d-flex justify-content-end">
      <button nbButton status="info" (click)="close()" i18n>Close</button>
    </div>
  </nb-card-footer>
</nb-card>
